import { RULESET as h, KEYFRAMES as d, DECLARATION as v, WEBKIT as u, MOZ as l, MS as E } from "./index.es114.js";
import { combine as g, replace as p, sizeof as b, match as x, assign as f, filter as m } from "./index.es232.js";
import { copy as s, lift as n } from "./index.es233.js";
import { serialize as M } from "./index.es116.js";
import { prefix as R } from "./index.es234.js";
function k(e) {
  var r = b(e);
  return function(t, o, a, w) {
    for (var c = "", i = 0; i < r; i++)
      c += e[i](t, o, a, w) || "";
    return c;
  };
}
function z(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function B(e, r, t, o) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case v:
        e.return = R(e.value, e.length, t);
        return;
      case d:
        return M([s(e, { value: p(e.value, "@", "@" + u) })], o);
      case h:
        if (e.length)
          return g(t = e.props, function(a) {
            switch (x(a, o = /(::plac\w+|:read-\w+)/)) {
              // :read-(only|write)
              case ":read-only":
              case ":read-write":
                n(s(e, { props: [p(a, /:(read-\w+)/, ":" + l + "$1")] })), n(s(e, { props: [a] })), f(e, { props: m(t, o) });
                break;
              // :placeholder
              case "::placeholder":
                n(s(e, { props: [p(a, /:(plac\w+)/, ":" + u + "input-$1")] })), n(s(e, { props: [p(a, /:(plac\w+)/, ":" + l + "$1")] })), n(s(e, { props: [p(a, /:(plac\w+)/, E + "input-$1")] })), n(s(e, { props: [a] })), f(e, { props: m(t, o) });
                break;
            }
            return "";
          });
    }
}
export {
  k as middleware,
  B as prefixer,
  z as rulesheet
};
//# sourceMappingURL=index.es115.js.map
